import { BasePostInputModel } from "../../../../models/http/InputModel/BasePostInputModel"
import { NovelMeta } from "../../../../models/tieup/novel/NovelMets"

export class MypageNovelPostInputModel extends BasePostInputModel {
  constructor(private params: NovelMeta) {
    super()
  }

  get body(): Record<string, unknown> {
    return {
      another_site_url: this.params.anotherSiteUrl,
      catch_copy: this.params.catchCopy,
      is_grotesque: this.params.isGrotesque,
      is_sexual: this.params.isSexual,
      is_violence: this.params.isViolence,
      original_genres: this.params.originalGenres,
      readers_number: this.params.readersNumber,
      title: this.params.title,
      is_r15: this.params.isR15,
      is_r18: this.params.isR18,
      hashtags: this.params.hashtags.map((v) => v.id),
      genres: this.params.genres.map((v) => v.id),
    }
  }
}
